<template>
  <div class="Head" :style="{ height: headFixed + 'px' }" v-resize="getH">
    <div class="HeadFixed" ref="Head">
      <div class="content">
        <div class="content_2">
          <div class="fl logo">
            <!-- <img src="../../assets/logo.png" @load="getH" class="fl" />
						<div class="fl f30 b ml15 logo_name">大众物流</div>
						<div class="fl f16 c6 ml15 mt10 hidden-xs-only">一站式物流管理和定制化服务</div>
						<div class="cl"></div> -->
            <img src="../../assets/logo2.png" @load="getH" class="fl" />
            <div class="hidden-xs-only desc">一站式物流管理和定制化服务</div>
            <div class="cl"></div>
          </div>
          <div class="fr hidden-xs-only" @mouseleave="activeTab = routerTab">
            <el-tabs v-model="activeTab">
              <template v-for="item in tabs">
                <el-tab-pane :name="item.tab">
                  <template #label>
                    <el-dropdown v-if="item.dropdown">
                      <!-- 业务咨询 -->
                      <span class="el-dropdown-link">
                        <div
                          class="tab"
                          @mouseenter="mousemove(item.tab)"
                          @click="link(item.dropdown[0].tab)"
                        >
                          {{ item.name }}
                        </div>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu
                          @mousemove="mousemove(item.tab)"
                          @mouseleave="activeTab = routerTab"
                        >
                          <el-dropdown-item
                            v-for="(d, i) in item.dropdown"
                            :key="i"
                            :divided="i > 0"
                            @click="dropdown(d.tab, item.tab)"
                          >
                            <span>{{ d.name }}</span>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <div
                      v-else
                      class="tab"
                      @mouseenter="mousemove(item.tab)"
                      @click="link(item.tab)"
                    >
                      <!-- 其他 -->
                      {{ item.name }}
                    </div>
                  </template>
                </el-tab-pane>
              </template>
            </el-tabs>
          </div>
          <div class="fr show-xs-only">
            <i
              class="el-icon-menu f22 blue mt2"
              @click="showMenu = !showMenu"
            ></i>
          </div>
          <div class="cl"></div>
        </div>
      </div>
      <!-- 移动端菜单 -->
      <el-drawer v-model="showMenu" size="80%" :with-header="false">
        <div class="f5">
          <div class="yy p3v bet pr" style="z-index: 2">
            <i class="el-icon-menu f22 blue" @click="showMenu = !showMenu"></i>
            <div class="logo" style="height: 26px">
              <!-- <img src="../../assets/logo2.png" class="fl" /> -->
              <!-- <div class="fl f30 b ml15 logo_name">大众物流</div> -->
              <div class="cl"></div>
            </div>
          </div>
          <div
            class="oa"
            :style="{ height: 'calc(100vh - ' + headFixed + 'px)' }"
          >
            <template v-for="(item, i) in tabs">
              <template v-if="item.tab == 'Business'"
                ><!-- 业务咨询 -->
                <div
                  :key="i"
                  class="borb1 ptb15 plr20 f16 active bet"
                  :class="{ 'bluebg ff': item.tab == routerTab }"
                  @click="businessShow = !businessShow"
                >
                  <span>{{ item.name }}</span>
                  <i
                    class="c9"
                    :class="[businessShow ? 'el-icon-minus' : 'el-icon-plus']"
                  ></i>
                </div>
                <el-collapse-transition :key="i">
                  <div class="bff pl8v" v-show="businessShow">
                    <div
                      class="ptb15 plr20 f16 borb1"
                      v-for="d in item.dropdown"
                      :key="d.tab"
                      @click="dropdown(d.tab)"
                    >
                      {{ d.name }}
                    </div>
                  </div>
                </el-collapse-transition>
              </template>
              <template v-else-if="item.tab == 'GSJJ'"
                ><!-- 关于我们 -->
                <div
                  :key="i"
                  class="borb1 ptb15 plr20 f16 active bet"
                  :class="{ 'bluebg ff': item.tab == routerTab }"
                  @click="aboutShow = !aboutShow"
                >
                  <span>{{ item.name }}</span>
                  <i
                    class="c9"
                    :class="[aboutShow ? 'el-icon-minus' : 'el-icon-plus']"
                  ></i>
                </div>
                <el-collapse-transition :key="i">
                  <div class="bff pl8v" v-show="aboutShow">
                    <div
                      class="ptb15 plr20 f16 borb1"
                      v-for="d in item.dropdown"
                      :key="d.tab"
                      @click="dropdown(d.tab)"
                    >
                      {{ d.name }}
                    </div>
                  </div>
                </el-collapse-transition>
              </template>
              <template v-else
                ><!-- 其他 -->
                <div
                  :key="i"
                  class="borb1 ptb15 plr20 f16 active"
                  :class="{ 'bluebg ff': item.tab == routerTab }"
                  @click="link(item.tab)"
                >
                  <span>{{ item.name }}</span>
                </div>
              </template>
            </template>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headFixed: 0,
      showMenu: false,
      businessShow: false,
      aboutShow: false,
      activeTab: "Home",
      routerTab: "Home",
      tabs: [
        {
          name: "网站首页",
          tab: "Home",
        },
        {
          name: "关于我们",
          tab: "GSJJ",
          dropdown: [
            {
              name: "公司简介",
              tab: "GSJJ",
            },
            {
              name: "发展历程",
              tab: "FZLC",
            },
            {
              name: "业务板块",
              tab: "YWBK",
            },
            {
              name: "组织机构",
              tab: "ZZJG",
            },
            {
              name: "服务理念",
              tab: "FWLN",
            },
            {
              name: "资质荣誉",
              tab: "ZZRY",
            },
            {
              name: "企业优势",
              tab: "QYYS",
            },
          ],
        },
        {
          name: "业务功能",
          tab: "Business",
          dropdown: [
            {
              name: "物流规划咨询",
              tab: "WLGHZX",
              en: "Logistics planning consultation",
            },
            {
              name: "智能装备制造与集成",
              tab: "ZNZBZZYJC",
              en: "Intelligent OEM & integration",
            },
            {
              name: "智慧物流软件开发",
              tab: "ZHWLRJKF",
              en: "Intelligent logistics softdevelop",
            },
            {
              name: "供应链服务",
              tab: "GYLFW",
              en: "Supply chain services",
            },
          ],
        },
        {
          name: "公司动态",
          tab: "News",
        },
        {
          name: "合作案例",
          tab: "Case",
        },
        {
          name: "服务流程",
          tab: "Service",
        },
        {
          name: "账务公开",
          tab: "Btz",
        },
        {
          name: "联系我们",
          tab: "Us",
        },
      ],
    };
  },
  watch: {
    "$store.state.link"() {
      this.$nextTick(() => {
        //页面加载完成后执行
        this.initTab();
      });
    },
  },
  created() {
    this.initTab();
  },
  mounted() {
    this.getH();
  },
  methods: {
    getH() {
      this.$nextTick(() => {
        this.headFixed = this.$refs["Head"].offsetHeight;
      });
    },
    initTab() {
      let t = false;
      this.tabs.forEach((x) => {
        if (this.$route.href.includes(x.tab)) {
          this.activeTab = this.routerTab = x.tab;
          t = true;
        } else if (this.$route.href.includes("About")) {
          this.activeTab = this.routerTab = "GSJJ";
          t = true;
        }
      });
      if (!t) {
        this.activeTab = this.routerTab = "Home";
      }
    },
    mousemove(activeTab) {
      this.activeTab = activeTab;
    },
    link(tab) {
      console.log(tab);
      if (tab == "Btz") {
        window.open(this.$store.state.btz.url);
        return;
      }
      this.routerTab = tab;
      this.$router.push({
        name: tab,
      });
      this.showMenu = false;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    dropdown(tab, tabf) {
      this.routerTab = tabf;
      this.$router.push({
        name: tab,
      });
      this.showMenu = false;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss">
.Head {
  background-color: #fff;
  .HeadFixed {
    padding: 30px 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    background-color: #fff;
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.1);
    z-index: 20;

    @media screen and (max-width: 1570px) {
      padding: 20px 0;
    }

    @media only screen and (max-width: 768px) {
      padding: 3vw;
      position: fixed;

      .logo_name {
        font-size: 16px;
        margin-left: 3vw;
      }
    }

    .logo {
      img {
        width: auto;
        height: 40px;
      }

      @media screen and (max-width: 1570px) {
        display: flex;
        align-items: center;
        margin-top: 5px;

        img {
          height: 30px;
        }
      }

      @media only screen and (max-width: 768px) {
        margin-top: 0;
        img {
          height: 26px;
        }
      }
    }

    .desc {
      float: left;
      font-size: 16px;
      color: #666;
      margin-left: 15px;
      margin-top: 10px;

      @media screen and (max-width: 1570px) {
        margin-top: 0;
        margin-left: 10px;
        font-size: 14px;
      }

      @media screen and (max-width: 1200px) {
        display: none;
      }
    }

    .el-tabs__nav-wrap {
      &::after {
        display: none;
      }

      .tab {
        font-size: 16px;
        line-height: 40px !important;
        cursor: pointer;
      }
    }

    .el-tabs__item {
      padding: 0 16px;

      @media screen and (max-width: 1200px) {
        padding: 0 12px;
      }

      &:hover {
        cursor: default;
      }
    }

    .el-tabs__header {
      margin: 0;
    }
  }
}
</style>
